





















































import Vue from 'vue';
import VueGallery from 'vue-gallery';
import jQuery from 'jquery';

const IMAGES_PER_PAGE = 9;

/*
  TODOs
  - Fix the infinite scrolling on the gallery so that pages are switched automatically
  - Add loading spinner while things are loading
  - Add pages in the url so you can jump around
*/

export default Vue.extend({
  mounted() {
    jQuery.get('https://res.cloudinary.com/lastwave/image/list/browser_upload.json', (res) => {
      res.resources.forEach((imageResource: any) => {
        const version = imageResource.version;
        const imageName = imageResource.public_id;
        this.allImages.push(`https://res.cloudinary.com/lastwave/image/upload/${imageName}.png`);
      });
    });
  },
  data() {
    return {
      allImages: [] as string[],
      index: null,
      currentPage: 0,
    };
  },
  computed: {
    thisPageImages(): string[] {
      const firstImage = this.currentPage * IMAGES_PER_PAGE;
      const lastImage = firstImage + IMAGES_PER_PAGE;
      return this.allImages.slice(firstImage, lastImage);
    },
    pageCount(): number {
      return Math.ceil(this.allImages.length / IMAGES_PER_PAGE);
    },
  },
  components: {
    gallery: VueGallery,
  },
});
